import { toast } from "react-toastify";

// for show option or hide based on isCollapsibleOption
export function shouldShowOptions({ addon, selectedAddon, quantity }) {
  const numOptions = addon.options?.length || 0;

  if (!addon.isCollapsibleOption && numOptions <= 3) return true;

  if (addon.isCountable) {
    return quantity > 0;
  }

  return selectedAddon?.enabled;
}

export function getAddonQuantity({ addon, selectedAddon, foodItemQuantity, isChecked, isLinked }) {
  // debugger
  if (!addon) return 0;

  if (!selectedAddon) return 0;

  // 1. Checked + Non-countable + Linked → Take food quantity
  if (isChecked && !addon.isCountable && addon.isCountableLinked) {
    return foodItemQuantity;
  }

  // 2. Linked toggle (addon)
  if (isLinked) {
    return selectedAddon?.enabled ? foodItemQuantity : 0;
  }

  // 3. Countable
  if (addon.isCountable) {
    return selectedAddon?.quantity || 0;
  }

  // 4. Non-countable + Non-linked → Sum option quantities
  if (!addon.isCountable && !addon.isCountableLinked) {
    return Object.entries(selectedAddon?.options || {}).reduce((total, [optionId, optionSel]) => {
      if (!optionSel?.enabled) return total;

      const optionDef = (addon.options || []).find(o => o.optionId === optionId);
      if (!optionDef) return total;

      const optionQty = optionDef.isCountableLinked
        ? foodItemQuantity
        : (optionSel.quantity || 1);

      return total + optionQty;
    }, 0);
  }
  return foodItemQuantity;
}

// getOptionQuantity function 
export function getOptionQuantity({ addon, selectedAddon, optionDef, optionSel, foodItemQuantity }) {
  return addon.isCountable && !optionDef.isCountableLinked
    ? selectedAddon.quantity || 0
    : optionDef.isCountableLinked
    ? foodItemQuantity
    : optionDef.isCountable
    ? optionSel.quantity || 0
    : 1;
}

// getOptionPrice function 
export function getOptionPrice({ optionDef, optionQty }) {
  return (optionDef.basePrice || 0) * optionQty;
}

// calculate suboption quantity
export function getSubOptionQuantity({ optionQty }) {
  return optionQty; // Sub-option uses parent option quantity
}

// calculate suboption price
export function getSubOptionPrice({ subOptionDef, subOptionQty }) {
  return (subOptionDef.price || 0) * subOptionQty;
}

export const validateMandatoryAddonsOption = (food, selectedAddons) => {
  // debugger
   // Check for mandatory addons
    const mandatoryAddons = food.addOns.filter((addon) => addon.isMandatory);
    for (const addon of mandatoryAddons) {
      const selectedAddon = selectedAddons[addon.id];
      const isSelected =
        selectedAddon?.enabled || selectedAddon?.quantity > 0 ||
        Object.values(selectedAddon?.options || {}).some((opt) => opt.enabled);
      if (!isSelected) {
        toast.warning(
          `Please select the mandatory addon ${addon.addOnName} to add to cart`
        );
        return;
      }
    }

    // Check mandatory options only if addon is selected
    for (const addon of food.addOns) {
      const selectedAddon = selectedAddons[addon.id] || { enabled: false, quantity: 0, options: {} };
    
      const isAddonSelected =
        selectedAddon?.enabled ||
        selectedAddon?.quantity > 0 ||
        Object.values(selectedAddon.options).some((opt) => opt.enabled);

      if (!isAddonSelected) {
        continue;
      }

      const mandatoryOptions = addon.options?.filter((option) => option.isMandatory) || [];

      for (const option of mandatoryOptions) {
        const selectedOption = selectedAddon?.options?.[option.optionId];
        const isOptionSelected = selectedOption?.enabled;

        if (!isOptionSelected) {
          toast.warning(
            `Please select the mandatory option ${option.optionName} in ${addon.addOnName} to add to cart`
          );
          return;
        }
      }
    }
    return true;
}

